import actions from './actions';

const {
  GET_DATA_SHOPPINGS,
  GET_DATA_BEGIN,
  GET_DATA_FINISH,
  SET_DATA_SHOPPINGS,
  SET_DATA_NEW_SHOPPING,
} = actions;

const initialState = {
  data: [],
  total: 0,
  loading: false,
};

const shoppingsReducer = (state = initialState, action:any) => {
  const { type, data } = action;
  switch (type) {
    case GET_DATA_SHOPPINGS:
      return {
        ...state
      };
    case GET_DATA_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_DATA_FINISH:
      return {
        ...state,
        loading: false,
      };
    case SET_DATA_SHOPPINGS:
      return {
        ...state,
        data: data,
        total: data.totalResults,
        loading: false,
      };
    case SET_DATA_NEW_SHOPPING:
      return {
        ...state,
        data: [data, ...state.data],
      };
    default:
      return state;
  }
};
export { shoppingsReducer };
